// EXEMPT
import {
  IS_APP,
  IS_CHINA,
  IS_DEV,
  IS_DEV_QUERY,
  IS_NODE,
  IS_STAGING,
  // IS_TESTING,
} from "@/__main__/constants.mjs";
// import getOSType from "@/util/get-os-type.mjs";
import hasQueryString from "@/util/has-query-string.mjs";

// Feature flags actually do not have to be enumerated, because feature modules
// are dynamically imported.
const featureDefaults = {
  // Dev only
  eventReplay: IS_DEV && IS_APP,
  docs: IS_DEV,
  dummy: IS_DEV || IS_NODE,

  // TODO: REMOVE ALL THIS SHIET
  ads: false,
  adsEnable: false,
  adsInfeedBanner: false,
  adsInContentBanner: false,
  adsLr: false,
  adsProfileVideo: false,
  adsVideo: false,
  adsSkin: false,
  adsOutstream: false,
  disableBackgroundAdsRefresh: false,

  // TODO: REMOVE THE FOLLOWING COMMENTS
  // Why is this usually true?
  // For a rather nitpicky reason, and that is cumulative layout shift.
  // This doesn't instantly load third party scripts, but it does
  // kind of penalize Pro users with the layout shift instead.
  // ads: !IS_DEV && getOSType() !== "mobile",

  // adsEnable: hasQueryString("__BLITZ_ADS_ENABLE__"),
  // adsInfeedBanner: !IS_DEV || hasQueryString("__BLITZ_ADS_INFEED_BANNER__"),
  // adsHeaderBanner: hasQueryString("__BLITZ_ADS_HEADER_BANNER__"),
  // adsInContentBanner: hasQueryString("__BLITZ_ADS_IN_CONTENT_BANNER__"),
  // adsLr: true,
  // adsProfileVideo: hasQueryString("__BLITZ_PROFILE_VIDEO__"),
  // adsVideo: IS_TESTING || hasQueryString("__BLITZ_VIDEO__"),
  // adsVideoNew: !IS_DEV && hasQueryString("__BLITZ_ADS_VIDEO_NEW__"),
  // adsSkin: hasQueryString("__BLITZ_ADS_SKIN__"),
  // adsOutstream: hasQueryString("__BLITZ_OUTSTREAM_VIDEO__"),
  // disableBackgroundAdsRefresh: hasQueryString(
  //   "__BLITZ_DISABLE_BACKGROUND_ADS_REFRESH__",
  // ),

  adsBaseline: !IS_DEV,
  adsAditude: false,

  // Generally don't turn this off, except in regions where this
  // doesn't apply lol.
  consent: !IS_DEV && !IS_CHINA,

  // User related stuff
  auth: !IS_CHINA,
  bridge: IS_APP,
  subscriber: !IS_CHINA,
  wallet: !IS_CHINA,

  crypto: false,

  battles: false,
  survey: IS_APP,

  // Maby turn off for Pro users
  analytics: !(IS_DEV || IS_NODE),
  // Will enable analytics but intercept the actual sending
  analyticsDev: false, // IS_DEV,

  china: IS_CHINA,

  // Used to show the debug toggle in settings, activation is a separate action
  // initiated by the user for RUM sessions.
  // This has been disabled due to lagging app startup and nobody is paying
  // attention to the output.
  // debug: !IS_CHINA && !IS_TESTING,
  debug: false,
  datadog: false,

  // I thought this is too noisy...
  // webVitals: !IS_NODE && IS_DEV,

  memTrim: false,

  // If staging is enabled in prod, then we should absolutely ensure this is enabled
  // so that they know that they are in a staging environment and can toggle it off.
  gameshark: IS_DEV || IS_STAGING,

  lolCoaching: true,
  lolRustBe: true, // There is conditional logic in the mod setup
  lolDev: IS_DEV_QUERY,
  valCoaching: true, // IS_DEV || hasQueryString("__BLITZ_VAL_POSTMATCH_RADIALS__"),
  valRustBe: true,

  replayCs2: false,

  // staged game rollouts
  eftRollout: IS_DEV || hasQueryString("__BLITZ_EFT_ROLLOUT__"),

  news: true,
  cms: IS_DEV,
  replayBlitzMessage: IS_DEV,
};

// export default { dummy: true };
export default featureDefaults;
